// Add your JS customizations here
AOS.init();

import "./modules/header"
import "./modules/home-featured-projects"
import "./modules/home-statistics"
import "./modules/photoslider"
import "./modules/accordion"
import "./modules/custom-select"
import "./modules/related-news"
import "./modules/related-team"
import "./modules/related-projects"
import "./modules/loadmore-projects"
import "./modules/loadmore-news"
import "./modules/careers-cta"

jQuery( document ).ready(function($) {
	
	// Lists split across columns, make them appear as one continuous list when stacked
	$('.wp-block-columns').each(function(){
		var columnWrap = $(this);
		var listTags = ['ul', 'ol'];

		if( $('.wp-block-column', columnWrap).length != 2 ){
			return;
		}

		var col1LastTag = $('.wp-block-column', columnWrap).eq(0).find('> *:last-child');
		var col2FirstTag = $('.wp-block-column', columnWrap).eq(1).find('> *:first-child');

		if( 
			jQuery.inArray(col1LastTag.prop('tagName').toLowerCase(), listTags) !== -1 && // first column first tag is list
			jQuery.inArray(col2FirstTag.prop('tagName').toLowerCase(), listTags) !== -1 &&  // second column first tag is list
			col1LastTag.prop('tagName').toLowerCase() == col2FirstTag.prop('tagName').toLowerCase() // first and second column lists are same type
		){
			columnWrap.addClass('split-list');
		}
	});
    
});